var React = require('react');

function TailwindcssIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"x1":"0","y1":"-21.333","y2":"85.333","id":"A","x2":"64","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#fff","offset":"0%","key":0}),React.createElement("stop",{"stopColor":"#fff","offset":"100%","key":1})])),React.createElement("path",{"d":"M16 25.6c2.133-8.533 7.467-12.8 16-12.8 12.8 0 14.4 9.6 20.8 11.2 4.267 1.067 8-.533 11.2-4.8C61.867 27.733 56.533 32 48 32c-12.8 0-14.4-9.6-20.8-11.2-4.267-1.067-8 .533-11.2 4.8zM0 44.8C2.133 36.267 7.467 32 16 32c12.8 0 14.4 9.6 20.8 11.2 4.267 1.067 8-.533 11.2-4.8-2.133 8.533-7.467 12.8-16 12.8-12.8 0-14.4-9.6-20.8-11.2-4.267-1.067-8 .533-11.2 4.8z","fill":"url(#A)","fillRule":"evenodd","key":1})]);
}

TailwindcssIcon.defaultProps = {"width":"64","height":"64"};

module.exports = TailwindcssIcon;

TailwindcssIcon.default = TailwindcssIcon;
